import * as THREE from 'three';
import mipmapper from "../cine/effects/mipmapper";
import fboHelper from "../cine/helpers/fboHelper";
import blueNoise from "../cine/effects/blueNoise";
import glPositionOffset from "../cine/effects/glPositionOffset";
import * as glslify from "glslify";
import shaderHelper from "../cine/helpers/shaderHelper";


export default class TestScene {
    // TEXTURE_PATH;
    //
    // /**
    //  * Set our global variables.
    //  */
    // camera;
    // scene;
    // renderer;
    // effect;
    // controls;
    // element;
    // container;
    // rotationPoint;
    // lightRotationPoint;
    // sphere;
    // skybox;
    // textureCube;
    //
    // cube;
    // cubeMaterial;
    // mirrorSphere;
    // mirrorSphereCamera;
    // mirrorRect1;
    // mirrorRect1Camera;
    // mirrorRect2;
    // mirrorRect2Camera;
    // mirrorRect3;
    // mirrorRect3Camera;
    // mirrorRect4;
    // mirrorRect4Camera;

    constructor(_options) {

        this.updateBase2 = this.updateBase2.bind(this);

        blueNoise.init(_options);

        shaderHelper.addChunk("textureBicubic", glslify(["#define GLSLIFY 1\nvec4 cubic(float v) {\n    vec4 n = vec4(1.0, 2.0, 3.0, 4.0) - v;\n    vec4 s = n * n * n;\n    float x = s.x;\n    float y = s.y - 4.0 * s.x;\n    float z = s.z - 4.0 * s.y + 6.0 * s.x;\n    float w = 6.0 - x - y - z;\n    return vec4(x, y, z, w);\n}\n\n// https://stackoverflow.com/questions/13501081/efficient-bicubic-filtering-code-in-glsl\nvec4 textureBicubic(sampler2D t, vec2 texCoords, vec2 textureSize) {\n   vec2 invTexSize = 1.0 / textureSize;\n   texCoords = texCoords * textureSize - 0.5;\n\n    vec2 fxy = fract(texCoords);\n    texCoords -= fxy;\n    vec4 xcubic = cubic(fxy.x);\n    vec4 ycubic = cubic(fxy.y);\n\n    vec4 c = texCoords.xxyy + vec2 (-0.5, 1.5).xyxy;\n\n    vec4 s = vec4(xcubic.xz + xcubic.yw, ycubic.xz + ycubic.yw);\n    vec4 offset = c + vec4 (xcubic.yw, ycubic.yw) / s;\n\n    offset *= invTexSize.xxyy;\n\n    vec4 sample0 = texture2D(t, offset.xz);\n    vec4 sample1 = texture2D(t, offset.yz);\n    vec4 sample2 = texture2D(t, offset.xw);\n    vec4 sample3 = texture2D(t, offset.yw);\n\n    float sx = s.x / (s.x + s.y);\n    float sy = s.z / (s.z + s.w);\n\n    return mix(\n       mix(sample3, sample2, sx), mix(sample1, sample0, sx)\n    , sy);\n}\n\nvec4 textureBicubic(sampler2D t, vec2 texCoords, vec2 textureSize, vec4 clampRect) {\n   vec2 invTexSize = 1.0 / textureSize;\n   texCoords = texCoords * textureSize - 0.5;\n\n    vec2 fxy = fract(texCoords);\n    texCoords -= fxy;\n    vec4 xcubic = cubic(fxy.x);\n    vec4 ycubic = cubic(fxy.y);\n\n    vec4 c = texCoords.xxyy + vec2 (-0.5, 1.5).xyxy;\n\n    vec4 s = vec4(xcubic.xz + xcubic.yw, ycubic.xz + ycubic.yw);\n    vec4 offset = c + vec4 (xcubic.yw, ycubic.yw) / s;\n\n    offset *= invTexSize.xxyy;\n\n    vec4 sample0 = texture2D(t, clamp(offset.xz, clampRect.xy, clampRect.zw));\n    vec4 sample1 = texture2D(t, clamp(offset.yz, clampRect.xy, clampRect.zw));\n    vec4 sample2 = texture2D(t, clamp(offset.xw, clampRect.xy, clampRect.zw));\n    vec4 sample3 = texture2D(t, clamp(offset.yw, clampRect.xy, clampRect.zw));\n\n    float sx = s.x / (s.x + s.y);\n    float sy = s.z / (s.z + s.w);\n\n    return mix(\n       mix(sample3, sample2, sx), mix(sample1, sample0, sx)\n    , sy);\n}"]));
        shaderHelper.addChunk("textureSmoothstep", glslify(["#define GLSLIFY 1\n// http://www.iquilezles.org/www/articles/texture/texture.htm\nvec4 textureSmoothstep(sampler2D t, vec2 texCoords, vec2 textureSize) {\n\ttexCoords = texCoords * textureSize + 0.5;\n\tvec2 iTexCoords = floor( texCoords );\n\tvec2 fTexCoords = fract( texCoords );\n\ttexCoords = iTexCoords + fTexCoords*fTexCoords*(3.0-2.0*fTexCoords);\n\ttexCoords = (texCoords - 0.5)/textureSize;\n\treturn texture2D( t, texCoords );\n}"]));


        this.resources = _options.resources
        this.niceFloorTexture = this.resources.items.floorTexture




        this.renderer = _options.renderer;
        this.camera = _options.camera.instance;
        this.container = _options.container;

        this.TEXTURE_PATH = 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/123879/';

        this.animate = this.animate.bind(this);
        this.onLoadBase = this.onLoadBase.bind(this);

        this.init();
        this.animate();

    }


    /**
     * Initializer function.
     */
    init() {

        // Create the scene.
        var urls = [
            this.TEXTURE_PATH + 'px.jpg', this.TEXTURE_PATH + 'nx.jpg',
            this.TEXTURE_PATH + 'py.jpg', this.TEXTURE_PATH + 'ny.jpg',
            this.TEXTURE_PATH + 'pz.jpg', this.TEXTURE_PATH + 'nz.jpg',
        ];
        var loader = new THREE.CubeTextureLoader();
        loader.crossOrigin = "";
        var textureCube = loader.load(urls);
        textureCube.format = THREE.RGBFormat;
        // this.container = new THREE.Object3D();
        this.container.background = textureCube;

        // Create a rotation points.
        this.rotationPoint = new THREE.Object3D();
        this.rotationPoint.position.set(0, 0, 0);
        this.container.add(this.rotationPoint);

        // light rotation point.
        this.lightRotationPoint = new THREE.Object3D();
        this.lightRotationPoint.position.set(0, 0, 0);
        this.container.add(this.lightRotationPoint);

        // Create the camera.
        // this.camera = new THREE.PerspectiveCamera(
        //     45, // Angle
        //     window.innerWidth / window.innerHeight, // Aspect Ratio.
        //     1, // Near view.
        //     23000 // Far view.
        // );
        // this.camera.position.z = -1500;
        // this.camera.position.y = 200;

        // this.rotationPoint.add(this.camera);

        // Build the renderer.
        // this.renderer = new THREE.WebGLRenderer({antialias: true, alpha: true});
        // this.element = renderer.domElement;
        // renderer.setSize(window.innerWidth, window.innerHeight);
        // this.renderer.shadowMap.enabled;
        // container.appendChild(this.element);

        // Build the controls.
        // this.controls = new THREE.OrbitControls(this.camera, this.element);
        // this.controls.enablePan = true;
        // this.controls.enableZoom = true;
        // this.controls.maxDistance = 2000;
        // this.controls.minDistance = 500;
        // this.controls.target.copy(new THREE.Vector3(0, 200, 0));
        // this.camera.lookAt(new THREE.Vector3(0, 200, 0));

        // setOrientationControls(e) {
        //     if (!e.alpha) {
        //         return;
        //     }
        //
        //     controls = new THREE.DeviceOrientationControls( camera );
        //     controls.connect();
        //
        //     window.removeEventListener('deviceorientation', setOrientationControls, true);
        // }
        // window.addEventListener('deviceorientation', setOrientationControls, true);

        // Ambient lights
        var ambient = new THREE.AmbientLight(0xffffff);
        this.container.add(ambient);

        var sun = new THREE.PointLight(0xffffcc, 100, 1000);
        sun.position.set(0, 0, 5);
        this.container.add(sun);

        var sun1 = new THREE.PointLight(0xffffcc, 1, 6000);
        sun1.position.set(-4000, 1000, -4000);
        this.container.add(sun1);

        var sun2 = new THREE.PointLight(0xffffcc, 1, 6000);
        sun2.position.set(-4000, 1000, 4000);
        this.container.add(sun2);

        var sun3 = new THREE.PointLight(0xffffcc, 1, 6000);
        sun3.position.set(4000, 1000, 4000);
        this.container.add(sun3);

        var light = new THREE.PointLight(0x7777aa, 1, 1000);
        light.position.set(-200, 200, -175);
        this.lightRotationPoint.add(light);
        var geometry = new THREE.SphereBufferGeometry(10, 8, 8);
        var material = new THREE.MeshLambertMaterial({
            color: 0x7777aa,
            emissive: 0x7777aa,
        });
        var lightBall = new THREE.Mesh(geometry, material);
        lightBall.position.set(-200, 200, -175);
        this.lightRotationPoint.add(lightBall);

        var light2 = new THREE.PointLight(0xaa7777, 1, 1000);
        light2.position.set(200, 200, -175);
        this.lightRotationPoint.add(light2);
        var geometry = new THREE.SphereBufferGeometry(10, 8, 8);
        var material = new THREE.MeshLambertMaterial({
            color: 0xaa7777,
            emissive: 0xaa7777,
        });
        var lightBall = new THREE.Mesh(geometry, material);
        lightBall.position.set(200, 200, -175);
        this.lightRotationPoint.add(lightBall);

        var light3 = new THREE.PointLight(0xaaaaaa, 1, 1000);
        light3.position.set(200, 200, 175);
        this.lightRotationPoint.add(light3);
        var geometry = new THREE.SphereBufferGeometry(10, 8, 8);
        var material = new THREE.MeshLambertMaterial({
            color: 0xaaaaaa,
            emissive: 0xaaaaaa,
        });
        var lightBall = new THREE.Mesh(geometry, material);
        lightBall.position.set(200, 200, 175);
        this.lightRotationPoint.add(lightBall);

        var light4 = new THREE.PointLight(0x77aa77, 1, 1000);
        light4.position.set(-200, 200, 175);
        this.lightRotationPoint.add(light4);
        var geometry = new THREE.SphereBufferGeometry(10, 8, 8);
        var material = new THREE.MeshLambertMaterial({
            color: 0x77aa77,
            emissive: 0x77aa77,
        });
        var lightBall = new THREE.Mesh(geometry, material);
        lightBall.position.set(-200, 200, 175);
        this.lightRotationPoint.add(lightBall);

        var light5 = new THREE.PointLight(0x777777, 1, 1400);
        light5.position.set(0, 1000, 0);
        this.container.add(light5);

        // Create base.
        // this.createBase();
        this.createBase2();

        // // Create the main object.
        this.createSphere();
        //
        // // Create surrounding shapes.
        // this.createSphere1();
        // this.createSphere2();
        // this.createRect();
        // this.createCone();

        window.addEventListener('resize', this.onWindowResize, false);
    }

    /**
     * Events to fire upon window resizing.
     */
    onWindowResize() {
        // this.camera.aspect = window.innerWidth / window.innerHeight;
        // this.camera.updateProjectionMatrix();
        // this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    /**
     * Updates to apply to the scene while running.
     */
    update() {
        this.camera.updateProjectionMatrix();
    }

    /**
     * Render the scene.
     */
    render() {
        // Render the main sphere.
        if (this.mirrorSphere) {
            this.mirrorSphere.visible = false;
            this.mirrorSphereCamera.update(this.renderer, this.container);
            this.mirrorSphere.visible = true;
        }


        // Render the other materials.
        if (this.mirrorRect1) {
            this.mirrorRect1.visible = false;
            this.mirrorRect1Camera.update(this.renderer, this.container);
            this.mirrorRect1.visible = true;
        }

        if (this.mirrorRect2) {
            this.mirrorRect2.visible = false;
            this.mirrorRect2Camera.update(this.renderer, this.container);
            this.mirrorRect2.visible = true;
        }
        if (this.mirrorRect3) {
            this.mirrorRect3.visible = false;
            this.mirrorRect3Camera.update(this.renderer, this.container);
            this.mirrorRect3.visible = true;
        }
        if (this.mirrorRect4) {
            this.mirrorRect4.visible = false;
            this.mirrorRect4Camera.update(this.renderer, this.container);
            this.mirrorRect4.visible = true;
        }


        // Render the scene.
        // this.renderer.render(this.container, this.camera);

        // Rotate the lights.
        this.lightRotationPoint.rotation.y += 0.005;

        // Don't let the camera go too low.
        // if (this.camera.position.y < 30) {
        //     this.camera.position.y = 30;
        // }

        // Slowly rotate the scene.
        this.rotationPoint.rotation.y += 0.0005;
    }

    /**
     * Animate the scene.
     */
    animate() {
        requestAnimationFrame(this.animate);
        this.update();
        this.render();
    }

    createSphere() {
        var geometry = new THREE.SphereGeometry(2, 32, 32);
        this.mirrorSphereCamera = new THREE.CubeCamera(0.1, 500, 64);
        this.container.add(this.mirrorSphereCamera);
        var mirrorSphereMaterial = new THREE.MeshBasicMaterial({envMap: this.mirrorSphereCamera.renderTarget.texture});
        this.mirrorSphere = new THREE.Mesh(geometry, mirrorSphereMaterial);
        this.mirrorSphere.position.set(1, 0, 1);
        this.mirrorSphereCamera.position.set(0, 0, 0);
        this.container.add(this.mirrorSphere);
    }

    createBase() {
        // Create a floor.
        this.textureLoader = new THREE.TextureLoader();
        this.textureLoader.crossOrigin = "";
        this.textureLoader.load(this.TEXTURE_PATH + 'MetalRustRepolished001_COL_1K_SPECULAR.jpg', this.onLoadBase);
    }

    onLoadBase(texture) {

            var repeatX = 16;
            var repeatY = 16;

            texture.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
            texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
            texture.repeat.set(repeatX, repeatY);

            var normal = this.textureLoader.load(this.TEXTURE_PATH + 'MetalRustRepolished001_NRM_1K_SPECULAR.jpg');
            normal.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
            normal.wrapS = normal.wrapT = THREE.RepeatWrapping;
            normal.repeat.set(repeatX, repeatY);

            var ao = this.textureLoader.load(this.TEXTURE_PATH + 'MetalRustRepolished001_GLOSS_VAR2_1K_SPECULAR.jpg');
            ao.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
            ao.wrapS = normal.wrapT = THREE.RepeatWrapping;
            ao.repeat.set(repeatX, repeatY);

            var displace = this.textureLoader.load(this.TEXTURE_PATH + 'MetalRustRepolished001_DISP_1K_SPECULAR.jpg');
            displace.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
            displace.wrapS = displace.wrapT = THREE.RepeatWrapping;
            displace.repeat.set(repeatX, repeatY);

            var spec = this.textureLoader.load(this.TEXTURE_PATH + 'MetalRustRepolished001_REFL_1K_SPECULAR.jpg');
            spec.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
            spec.wrapS = spec.wrapT = THREE.RepeatWrapping;
            spec.repeat.set(repeatX, repeatY);

            var material = new THREE.MeshStandardMaterial({
                aoMap: ao,
                aoMapIntensity: 0.5,
                color: 0x666666,
                map: texture,
                metalnessMap: texture,
                displacementMap: displace,
                normalMap: normal,
                // envMap: this.container.background,
                metalness: 0.7,
                metalMap: texture,
                roughness: 0.2,
                combine: THREE.MixOperation,
                reflectivity: 0.3,
            });

            // material = new THREE.MeshBasicMaterial({ color: '#ffffff', depthWrite: false});

            // Create the floor geometry and mesh. Add to scene.
            var geometry = new THREE.PlaneGeometry(48, 48);
            geometry.computeFaceNormals();
            var floor = new THREE.Mesh(geometry, material);
            floor.position.set(-10, 10, -0.5);
            // floor.position = new THREE.Vector2(0, 0);
            // floor.rotation.x = -Math.PI / 2;
            floor.receiveShadow = true;
            this.container.add(floor);
    }

    createBase2() {

        // Texture
        this.niceFloorTexture.magFilter = THREE.NearestFilter
        this.niceFloorTexture.minFilter = THREE.LinearFilter

        this.niceFloorTexture.needsUpdate = true;
        this.niceFloorTexture.wrapS = this.niceFloorTexture.wrapT = THREE.RepeatWrapping;

        this.someVector2 = new THREE.Vector2;

        this.matrix = new THREE.Matrix4;
        /** @type {number} */
        this.someZeroNumber = 0;
        this.perspectiveCamera = new THREE.PerspectiveCamera;
        this.b = new THREE.Plane;
        this.v = new THREE.Vector3;
        this.p = new THREE.Vector3;
        this.vector = new THREE.Vector3;
        this.tempMatrix = new THREE.Matrix4;
        this.v1 = new THREE.Vector3;
        this.someOtherVector4 = new THREE.Vector4;
        this._vector3 = new THREE.Vector3;
        this.qVector = new THREE.Vector3;
        this.tVector = new THREE.Vector3;
        this.someVector4 = new THREE.Vector4;

        this.mipmapperInst = new mipmapper();
        this.renderTarget = fboHelper.createRenderTarget(1, 1)
        this.renderTarget.depthBuffer = true
        this.niceFloorMesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(128, 128), new THREE.ShaderMaterial({
            uniforms: {
                u_infoTexture: {
                    value: this.niceFloorTexture
                },
                u_textureMatrix: {
                    value: this.matrix
                },
                u_textureSize: {
                    value: this.someVector2
                },
                u_mipmapTextureSize: {
                    value: this.mipmapperInst.textureSize
                },
                u_mipmapTexture: {
                    value: this.renderTarget.texture
                },
                u_noiseTime: {
                    value: 0
                },
                // ...blueNoise.sharedUniforms,
                // ...glPositionOffset.sharedUniforms
            },
            vertexShader: glslify(["#define GLSLIFY 1\nuniform mat4 u_textureMatrix;\n\nvarying vec2 v_uv;\nvarying vec4 v_reflectionTextureUv;\n\n#include <glPositionOffset>\n\nvoid main () {\n\tv_uv = uv;\n\tv_reflectionTextureUv = u_textureMatrix * vec4( position, 1.0 );\n\n    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);\n\n    gl_Position = projectionMatrix * mvPosition;\n\t// gl_Position = glPositionOffset(gl_Position);\n}"]),
            fragmentShader: glslify(["#define GLSLIFY 1\nuniform sampler2D u_infoTexture;\n\nuniform sampler2D u_mipmapTexture;\nuniform vec2 u_textureSize;\nuniform vec2 u_mipmapTextureSize;\nuniform float u_noiseTime;\n\n#include <textureSmoothstep>\n#include <textureBicubic>\n#include <lodMipmapSample>\n\n#include <getBlueNoise>\n\nvarying vec4 v_reflectionTextureUv;\nvarying vec2 v_uv;\n\nvec2 mirrored(vec2 v) {\n    vec2 m = mod(v, 2.0);\n    return mix(m, 2.0 - m, step(1.0, m));\n}\n\nvoid main () {\n\tvec3 blueNoise = getBlueNoise(gl_FragCoord.xy);\n\t\n\tvec2 reflectionUv = v_reflectionTextureUv.xy / v_reflectionTextureUv.w + blueNoise.xy / u_mipmapTextureSize;\n    vec3 color = lodMipmapSampleNearest(u_mipmapTexture, reflectionUv, 0.0, u_textureSize, u_mipmapTextureSize).rgb;\n\t// vec3 info = texture2D(u_infoTexture, v_uv * 6.0).rgb;\n\tvec3 info;\n\tvec3 blury;\n\t#ifdef IS_MOBILE\n\tinfo = textureSmoothstep(u_infoTexture, v_uv * 6.0, vec2(1024.0)).rgb;\n    blury = lodMipmapSampleSmoothstep(u_mipmapTexture, reflectionUv + info.br / 128.0, info.r * info.g * 15.0, u_textureSize, u_mipmapTextureSize).rgb;\n\tcolor = mix(color, blury, clamp((info.g - 0.25) * 5.0, 0.0, 1.0));\n\t\n\tinfo = textureBicubic(u_infoTexture, v_uv * 2.0 + 0.421, vec2(1024.0)).rgb;\n    blury = lodMipmapSampleSmoothstep(u_mipmapTexture, reflectionUv, info.r * 6.0, u_textureSize, u_mipmapTextureSize).rgb;\n\tcolor = mix(color, blury, clamp((info.b + blueNoise.z * 0.05 - 0.3) *  7.0, 0.0, 1.0));\n\t#else\n\tinfo = textureBicubic(u_infoTexture, v_uv * 6.0, vec2(1024.0)).rgb;\n    blury = lodMipmapSampleCubic(u_mipmapTexture, reflectionUv + info.br / 128.0, info.r * info.g * 15.0, u_textureSize, u_mipmapTextureSize).rgb;\n\tcolor = mix(color, blury, clamp((info.g - 0.25) * 5.0, 0.0, 1.0));\n\t\n\tinfo = textureBicubic(u_infoTexture, v_uv * 2.0 + 0.421, vec2(1024.0)).rgb;\n    blury = lodMipmapSampleCubic(u_mipmapTexture, reflectionUv, info.r * 6.0, u_textureSize, u_mipmapTextureSize).rgb;\n\tcolor = mix(color, blury, clamp((info.b + blueNoise.z * 0.05 - 0.3) *  7.0, 0.0, 1.0));\n\t#endif\n\n\tcolor *= mix(0.6, 0.75, info.g);\n\n\tgl_FragColor = vec4(color + blueNoise.rgb / 128.0, 1.0);\n}"])
        }));

        this.niceFloorMesh.onBeforeRender = this.updateBase2;
        this.container.add(this.niceFloorMesh)
        this.niceFloorMesh.position.z = -0.5


        this.resizeBase2(window.innerWidth, window.innerHeight);
    }

    updateBase2(renderer, input, camera) {
        if (!this.someVector2) {
            return;
        }
        this.p.setFromMatrixPosition(this.niceFloorMesh.matrixWorld);
        this.vector.setFromMatrixPosition(camera.matrixWorld);
        this.tempMatrix.extractRotation(this.niceFloorMesh.matrixWorld);
        this.v.set(0, 0, 1);
        this.v.applyMatrix4(this.tempMatrix);
        this.qVector.subVectors(this.p, this.vector)


        if (!(0 < this.qVector.dot(this.v))) {
            this.qVector.reflect(this.v).negate();
            this.qVector.add(this.p);
            this.tempMatrix.extractRotation(camera.matrixWorld);
            this.v1.set(0, 0, -1);
            this.v1.applyMatrix4(this.tempMatrix);
            this.v1.add(this.vector);
            this.tVector.subVectors(this.p, this.v1);
            this.tVector.reflect(this.v).negate();
            this.tVector.add(this.p);
            this.perspectiveCamera.position.copy(this.qVector);
            this.perspectiveCamera.up.set(0, 1, 0);
            this.perspectiveCamera.up.applyMatrix4(this.tempMatrix);
            this.perspectiveCamera.up.reflect(this.v);
            this.perspectiveCamera.lookAt(this.tVector);
            this.perspectiveCamera.near = camera.near;
            this.perspectiveCamera.far = camera.far;
            this.perspectiveCamera.updateMatrixWorld();
            this.perspectiveCamera.projectionMatrix.copy(camera.projectionMatrix);
            this.matrix.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1);
            this.matrix.multiply(this.perspectiveCamera.projectionMatrix);
            this.matrix.multiply(this.perspectiveCamera.matrixWorldInverse);
            this.matrix.multiply(this.niceFloorMesh.matrixWorld);
            this.b.setFromNormalAndCoplanarPoint(this.v, this.p);
            this.b.applyMatrix4(this.perspectiveCamera.matrixWorldInverse);
            this.someOtherVector4.set(this.b.normal.x, this.b.normal.y, this.b.normal.z, this.b.constant);
            var m = this.perspectiveCamera.projectionMatrix;
            /** @type {number} */
            this.someVector4.x = (Math.sign(this.someOtherVector4.x) + m.elements[8]) / m.elements[0];
            /** @type {number} */
            this.someVector4.y = (Math.sign(this.someOtherVector4.y) + m.elements[9]) / m.elements[5];
            /** @type {number} */
            this.someVector4.z = -1;
            /** @type {number} */
            this.someVector4.w = (1 + m.elements[10]) / m.elements[14];
            this.someOtherVector4.multiplyScalar(2 / this.someOtherVector4.dot(this.someVector4));
            m.elements[2] = this.someOtherVector4.x;
            m.elements[6] = this.someOtherVector4.y;
            /** @type {number} */
            m.elements[10] = this.someOtherVector4.z + 1 - this.someZeroNumber;
            m.elements[14] = this.someOtherVector4.w;
            this._vector3.setFromMatrixPosition(camera.matrixWorld);
            /** @type {boolean} */
            // renderer.xr.enabled = false;
            /** @type {boolean} */
            this.niceFloorMesh.visible = false;
            var textureTarget = renderer.getRenderTarget();
            /** @type {boolean} */
            // var tmpEnabled = renderer.xr.enabled;
            /** @type {boolean} */
            var currentSceneAutoUpdate = renderer.shadowMap.autoUpdate;
            /** @type {boolean} */
            // renderer.xr.enabled = false;
            /** @type {boolean} */
            renderer.shadowMap.autoUpdate = false;
            renderer.setRenderTarget(this.renderTarget);
            renderer.setViewport(0, 0, this.someVector2.x, this.someVector2.y);
            renderer.setScissor(0, 0, this.someVector2.x, this.someVector2.y);
            renderer.setScissorTest(true);
            renderer.render(input, this.perspectiveCamera);
            renderer.setRenderTarget(null);

            var renderRectL = {
                width: window.innerWidth,
                height: window.innerHeight
            }
            renderer.setViewport(0, 0, renderRectL.width, renderRectL.height);
            renderer.setScissor(0, 0, renderRectL.width, renderRectL.height);
            this.mipmapperInst.render(this.renderTarget);
            /** @type {boolean} */
            // renderer.xr.enabled = tmpEnabled;
            /** @type {boolean} */
            renderer.shadowMap.autoUpdate = currentSceneAutoUpdate;
            renderer.setRenderTarget(textureTarget);
            var width = camera.viewport;
            if (void 0 !== width) {
                renderer.state.viewport(width);
            }
            /** @type {boolean} */
            this.niceFloorMesh.visible = true;
            this.niceFloorMesh.material.uniforms.u_noiseTime.value += .01;

        }
    }

    resizeBase2(b, d) {
        if (!this.someVector2) {
            return;
        }
        /** @type {number} */
            // var a = platform.isMobile ? .5 : 1;
        var a = 1;
        /** @type {number} */
        b = b * a;
        /** @type {number} */
        d = d * a;
        this.someVector2.set(b, d);
        this.renderTarget.setSize(1.5 * this.someVector2.x, this.someVector2.y);
        this.mipmapperInst.resize(this.someVector2.x, this.someVector2.y, this.renderTarget.width, this.renderTarget.height);
    }

    createSphere1() {
        var geometry = new THREE.SphereGeometry(100, 32, 32);
        this.mirrorRect1Camera = new THREE.CubeCamera(0.1, 5000, 512);
        this.container.add(this.mirrorRect1Camera);
        var mirrorRectMaterial = new THREE.MeshBasicMaterial({envMap: this.mirrorRect1Camera.renderTarget.texture});
        this.mirrorRect1 = new THREE.Mesh(geometry, mirrorRectMaterial);
        this.mirrorRect1.position.set(500, 600, 500);
        this.mirrorRect1Camera.position.set(-500, 600, 500);// = this.mirrorRect1.position;
        this.container.add(this.mirrorRect1);
    }

    createSphere2() {
        var geometry = new THREE.SphereGeometry(100, 32, 32);
        this.mirrorRect2Camera = new THREE.CubeCamera(0.1, 5000, 512);
        this.container.add(this.mirrorRect2Camera);
        var mirrorRectMaterial = new THREE.MeshBasicMaterial({envMap: this.mirrorRect2Camera.renderTarget.texture});
        this.mirrorRect2 = new THREE.Mesh(geometry, mirrorRectMaterial);
        this.mirrorRect2.position.set(-500, 300, -500);
        this.mirrorRect2Camera.position.set(-500, 300, -500);
        this.container.add(this.mirrorRect2);
    }

    createRect() {
        var geometry = new THREE.CubeGeometry(2, 4, 2, 1, 1, 1,);
        this.mirrorRect3Camera = new THREE.CubeCamera(0.1, 5000, 512);
        this.container.add(this.mirrorRect3Camera);
        var mirrorRectMaterial = new THREE.MeshBasicMaterial({
            envMap: this.mirrorRect3Camera.renderTarget.texture,
            //reflectivity: 0.9,
            color: 0xaaaaaa,
        });
        this.mirrorRect3 = new THREE.Mesh(geometry, mirrorRectMaterial);
        this.mirrorRect3.position.set(3, -10, 1);
        this.mirrorRect3.rotation.set(THREE.Math.degToRad(90), 0, 0);
        this.mirrorRect3Camera.position.set(3, -10, 1);
        this.mirrorRect3Camera.rotation.set(THREE.Math.degToRad(90), THREE.Math.degToRad(90), THREE.Math.degToRad(90));
        this.container.add(this.mirrorRect3);
    }

    createCone() {
        var geometry = new THREE.ConeGeometry(200, 600, 64);
        this.mirrorRect4Camera = new THREE.CubeCamera(1, 1000, 512);
        this.container.add(this.mirrorRect4Camera);
        var mirrorRectMaterial = new THREE.MeshBasicMaterial({
            envMap: this.mirrorRect4Camera.renderTarget.texture,
        });
        this.mirrorRect4 = new THREE.Mesh(geometry, mirrorRectMaterial);
        this.mirrorRect4.position.set(500, 300, -500);
        this.mirrorRect4Camera.position.set(500, 300, -500);
        this.container.add(this.mirrorRect4);
    }

}
